import React from "react";
import { NewsEventModel } from "../../../domain/entities/NewsEventModel";
import NewsEventItemComponents from "./NewsEventItemComponents";

interface NewsAllEventListProps {
    newsList: NewsEventModel[]
}

const NewsAllEventListComponents: React.FC<NewsAllEventListProps> = ({newsList}) => {

    return (
        // Main container with relative positioning
        <div className="w-full mx-auto px-4 md:px-12 lg:px-12 py-4 md:py-6 relative mt-16 md:mt-16">
            {/* Heading */}
            <h4 className="text-2xl md:text-3xl font-bold text-start mb-6 md:mb-8 font-poppins">
                Berita dan Acara
            </h4>
    
            {/* Scroll container with position relative for overlay positioning */}
            <div className="relative">
                {/* Scrollable area with no padding to prevent cropping */}
                <div className="overflow-x-auto md:scroll-smooth">
                    {/* Content wrapper with padding to create space from edges */}
                    <div className="flex flex-col md:grid md:grid-cols-3 gap-3 md:gap-8 px-4">
                        {newsList.map((item) => (
                            <div 
                                key={item.id} 
                                className="w-full md:w-96 flex-shrink-0"
                            >
                                <NewsEventItemComponents 
                                    newsEvent={item} 
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewsAllEventListComponents;